import { BaseService } from './base.service'
import { ErrorWrapper, ResponseWrapper } from './util'

import storeHelper from '@/store/helper'
import FileDownload from 'js-file-download'
import moment from 'moment'
export class AttentdentService extends BaseService {
  // danh sách bản ghi điểm danh
  static async getList (params = {}) {
    
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.attn.backend.attentdent-list'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getWaitingApprovedAttendance (params = {}) {
    
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.attn.backend.attentdent-list-waiting'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  // chi tiết bản điểm danh
  static async getDetail (params = {}) {
    
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.attn.backend.attendance-detail'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  // danh sách bản ghi ccbs
  static async listTimeKeeping (params = {}) {
    
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.attn-add.list-on-web'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  // chi tiết 1 bản ghi ccbs
  static async timekeepingDetail (params = {}) {
    
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.attn-add.get-detail-by-id'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  // nhân viên hủy bản ghi ccbs
  static async saleCancel (params = {}) {
    
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.attn-add.sale-reject'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  // xuất excel ccbs
  static async timekeepingExport (params = {}) {
    
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.attn-add.export'), params, {
        responseType: 'blob'
      })

    if (response.headers['content-type'] == 'application/vnd.ms-excel') {
      FileDownload(response.data, 'ChamCongBoSung' + '_' + moment(new Date(new Date())).format('DD/MM/YYYY') + '.xlsx')
    } else return JSON.parse(await response.data.text())
      return {}
    } catch (error) {
      console.log(error)
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  // thêm mới bản ccbs
  static async timekeepingAdd (params = {}) {
    
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.attn-add.create'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  // sửa bản ghi ccbs
  static async timekeepingEdit (params = {}) {
    
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.attn-add.update'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  // duyệt, từ chối ccbs
  static async timekeepingApporovedOrReject (params = {}) {
    
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.attn-add.approve-reject'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  // xác nhận, không xác nhận ccbs
  static async timekeepingAcceptOrNotAccept (params = {}) {
    
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.attn-add.accept'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  // Duyet cham cong
  static async approveAttendance (params = {}) {
    
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.attn.backend.attendance-approve'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  // Tu choi cham cong
  static async rejectAttendance (params = {}) {
    
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.attn.backend.attendance-reject'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
}
